<template>
  <Modal :open.sync="open" size="large" data-cy="analytics-modal">
    <div class="dwp-space-y-8">
      <div class="dwp-space-y-3 dwp-mb-6 dwp-text-gray-600">
        <div
          class="dwp-text-2xl dwp-font-medium dwp-flex dwp-items-center dwp-space-x-2 dwp-text-gray-800"
        >Thanks for Using Docket WP!</div>
        <p>
          This is your invitation to help us make Docket WP even better! If you choose to help, some data about your usage of
          Docket WP will be shared with our team so we can continue to make improvements based on use—not assumption.
        </p>
        <p>If not, that's okay too—the software will still work fine.</p>
      </div>
      <div class="sm:dwp-flex sm:dwp-items-center sm:dwp-justify-between">
        <div class="dwp-flex dwp-items-center">
          <VButton
            data-cy="analytics-opt-in"
            size="huge"
            @click.native="analytics(true)"
          >Sure, I'm In!</VButton>
          <VButton
            type="plain"
            @click.prevent.native="open = false"
            @click.native="analytics(false)"
          >No Thanks</VButton>
        </div>
        <div
          @click="info = !info"
          class="dwp-cursor-pointer dwp-flex dwp-items-center dwp-text-sm dwp-text-gray-500 dwp-mt-3 sm:dwp-mt-0"
        >What information do you collect?</div>
      </div>
      <div v-if="info" class="dwp-py-10 dwp-px-4 dwp-bg-gray-100 dwp-rouned-md">
        <div class="dwp-grid dwp-space-y-8 md:dwp-space-y-0 md:dwp-grid-cols-2">
          <div class="dwp-space-y-3 dwp-px-6">
            <div class="dwp-text-xl dwp-text-gray-800 dwp-leading-tight">What we do collect</div>
            <ul class="dwp-space-y-2 dwp-text-gray-600">
              <li class="dwp-flex">
                <CheckIcon class="dwp-w-4 dwp-text-green-600 dwp-mr-2 dwp-flex-shrink-0" />Website URL.
              </li>
              <li class="dwp-flex">
                <CheckIcon class="dwp-w-4 dwp-text-green-600 dwp-mr-2 dwp-flex-shrink-0" />Site name.
              </li>
              <li class="dwp-flex">
                <CheckIcon class="dwp-w-4 dwp-text-green-600 dwp-mr-2 dwp-flex-shrink-0" />Docket WP plugin version.
              </li>
              <li class="dwp-flex">
                <CheckIcon class="dwp-w-4 dwp-text-green-600 dwp-mr-2 dwp-flex-shrink-0" />Your Country/Region (to help us with prioritizing language translations).
              </li>
              <li class="dwp-flex">
                <CheckIcon class="dwp-w-4 dwp-text-green-600 dwp-mr-2 dwp-flex-shrink-0" />Plugin Usage Events (importing a list, saving a list, making a new list, etc.).
              </li>
            </ul>
          </div>
          <div class="dwp-space-y-3 dwp-px-6">
            <div class="dwp-text-xl dwp-text-gray-800 dwp-leading-tight">
              What we
              <strong class="dwp-text-bold">don't</strong> collect.
            </div>
            <ul class="dwp-space-y-2 dwp-text-gray-600">
              <li class="dwp-flex">
                <XIcon class="dwp-w-4 dwp-text-red-600 dwp-mr-2 dwp-flex-shrink-0" />WordPress usage outside our plugin.
              </li>
              <li class="dwp-flex">
                <XIcon class="dwp-w-4 dwp-text-red-600 dwp-mr-2 dwp-flex-shrink-0" />Your WordPress user data.
              </li>
              <li class="dwp-flex">
                <XIcon class="dwp-w-4 dwp-text-red-600 dwp-mr-2 dwp-flex-shrink-0" />Any other WordPress users and their data.
              </li>
              <li class="dwp-flex">
                <XIcon class="dwp-w-4 dwp-text-red-600 dwp-mr-2 dwp-flex-shrink-0" />Other plugins and themes data.
              </li>
              <li class="dwp-flex">
                <XIcon class="dwp-w-4 dwp-text-red-600 dwp-mr-2 dwp-flex-shrink-0" />WordPress or server info.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import VButton from "@/components/ui/VButton.vue";
import { sync } from "vuex-pathify";
import * as Firebase from "firebase/app";
import { CheckIcon, XIcon } from "vue-feather-icons";

export default {
  components: {
    Modal,
    VButton,
    CheckIcon,
    XIcon,
  },

  data() {
    return {
      info: false,
    };
  },

  computed: {
    open: sync("ui/modal@analytics"),
  },

  methods: {
    async analytics(optIn) {
      this.$store.dispatch("user/patch", {
        analytics: !!optIn,
      });
      this.open = false;
    },
  },
};
</script>